// src/components/strumenti/ConversionePressione.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const PSI_PER_BAR = 14.5038;
const KPA_PER_BAR = 100;
const MCA_PER_BAR = 10.1972;

export default function ConversionePressione() {
  const [valore, setValore] = useState("");
  const [unita, setUnita] = useState("bar");

  const v = leggiNumero(valore)||0;
  const inBar = unita==="bar" ? v : unita==="psi" ? v/PSI_PER_BAR : unita==="kpa" ? v/KPA_PER_BAR : v/MCA_PER_BAR;

  const risultati = [
    { label:"bar", val:inBar },
    { label:"psi", val:inBar*PSI_PER_BAR },
    { label:"kPa", val:inBar*KPA_PER_BAR },
    { label:"m.c.a.", val:inBar*MCA_PER_BAR },
  ];

  return (
    <div>
      <div style={{ display:"flex", gap:8, marginBottom:16 }}>
        <input value={valore} onChange={e=>setValore(e.target.value)} placeholder="Valore"
          style={{ flex:1, padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}/>
        <select value={unita} onChange={e=>setUnita(e.target.value)}
          style={{ padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}>
          <option value="bar">bar</option>
          <option value="psi">psi</option>
          <option value="kpa">kPa</option>
          <option value="mca">m.c.a.</option>
        </select>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:10 }}>
        {risultati.map(r => (
          <div key={r.label} style={{ background: r.label===unita || (r.label==="m.c.a."&&unita==="mca") || (r.label==="kPa"&&unita==="kpa") ? "#eff6ff" : "#f9fafb",
            border:`1px solid ${r.label===unita||(r.label==="m.c.a."&&unita==="mca")||(r.label==="kPa"&&unita==="kpa")?"#bfdbfe":"#e5e7eb"}`, borderRadius:10, padding:"12px 10px", textAlign:"center" }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{r.label}</div>
            <div style={{ fontSize:16, fontWeight:800, color:"#2563eb" }}>{r.val.toLocaleString("it-IT",{maximumFractionDigits:2})}</div>
          </div>
        ))}
      </div>
      <button onClick={()=>{setValore("");setUnita("bar");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
